<template>
  <cf-validated-form
    name="twoFactorForm"
    @valid-submit="formSubmitHandler"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        {{ twoFactorContent.title }}
      </Teleport>

      <p class="cf-subtitle cf-subtitle--2">
        {{ twoFactorContent.description }}

        <br>

        <span class="bold">
          {{ maskedContactInfo }}
        </span>
      </p>

      <cf-text-input
        v-model="verificationCode"
        type="text"
        label="Passcode"
        icon-class="fa-key"
        name="passcode"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="one-time-code"
        class="cf-text-input--spaced-characters"
        :validations="{ required: true }"
      />

      <p class="cf-subtitle cf-subtitle--2">
        Didn't receive the passcode?

        <span
          class="cf-link cf-link--brand-secondary cf-link--heavy"
          @click="resendPasscodeHandler"
        >
          Resend It
        </span>
      </p>

      <button
        :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': isLoading }]"
        type="submit"
      >
        {{ twoFactorContent.cta }}
      </button>

    </div>
  </cf-validated-form>
</template>


<script>
  import { mapGetters } from 'vuex';

  import maskEmail from '@/helpers/mask-email';
  import maskPhone from '@/helpers/mask-phone';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'TwoFactorAuth',

    components: {
      CfValidatedForm,
      CfTextInput
    },

    props: {
      contactInfo: {
        type: String,
        required: true
      },

      contactType: {
        type: String,
        required: true
      },

      authType: {
        type: String,
        required: true
      },

      onSuccess: {
        type: Function,
        default: null
      }
    },

    data: () => ({
      verificationCode: null,
      isLoading: false
    }),

    computed: {
      ...mapGetters('content', ['content']),

      twoFactorContent() {
        return this.getContentType(this.authType);
      },

      maskedContactInfo() {
        return this.contactType === 'email' ? maskEmail(this.contactInfo) : maskPhone(this.contactInfo);
      }
    },

    methods: {
      async formSubmitHandler() {
        this.isLoading = true;

        const dispatchPayload = { contactInfo: this.contactInfo, contactType: this.contactType, verificationCode: this.verificationCode };

        const { isSuccess } = await this.$store.dispatch('session/submitTwoFactorAuthPasscode', dispatchPayload);

        if (isSuccess) {
          this.$closeAllModals();

          if (this.onSuccess) {
            this.onSuccess();
          }
        }

        this.isLoading = false;
      },

      async resendPasscodeHandler() {
        const dispatchPayload = { contactInfo: this.contactInfo, contactType: this.contactType };

        await this.$store.dispatch('session/resendTwoFactorAuthPasscode', dispatchPayload);
      },

      getContentType(authType) {
        const twoFactorAuth = this.content.TwoFactorAuthenticationModal;

        switch (authType) {
          case 'phone-already-exists-verification-required':
          case 'email-already-exists-verification-required':
            return { title: 'Two Factor Authentication', description: 'Verify it\'s you by entering the passcode sent to', cta: 'Verify' };
          default:
            return { title: twoFactorAuth.title, description: twoFactorAuth.description, cta: twoFactorAuth.metadata.cta };
        }
      }
    }
  };
</script>
